export default "__VITE_ASSET__CBxIOUy___"